import ServiceCategoryPage from "../components/ServiceCategoryPage";
import chimneyService from "../data/services/chimneyService";

function ChimneyService() {
  return <ServiceCategoryPage service={chimneyService} />;
}

export default ChimneyService;